import { FieldErrors } from 'react-hook-form';
import { Loan } from '../types/loan';

// Helper to get nested error by path (dot notation)
function getNestedError(errors: FieldErrors<Loan>, path: string): unknown {
  return path.split('.').reduce((obj, key) => {
    if (obj && typeof obj === 'object' && key in obj) {
      return (obj as Record<string, unknown>)[key];
    }
    return undefined;
  }, errors as unknown);
}

export function getErrorMessage(
  errors: FieldErrors<Loan>,
  name: string
): string | undefined {
  const error = getNestedError(errors, name);
  if (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof (error as { message: unknown }).message === 'string'
  ) {
    return (error as { message: string }).message;
  }
  return undefined;
}
